import React, { ComponentProps } from 'react';
import { RadioPanel } from './RadioPanel';
import { RadioPanelGroupTheme } from './common/RadioPanelGroupTheme';
import { RadioPanelBorderRadius } from './common/RadioPanelBorderRadius';
import { RadioPanelDropShadowType } from './common/RadioPanelDropShadowType';

type RadioPanelProps = ComponentProps<typeof RadioPanel>;

export const RadioPanelGroup: React.FC<{
    id: string;
    items: RadioPanelProps[];
    theme: RadioPanelGroupTheme;
    borderRadius: RadioPanelBorderRadius;
    dropShadowType: RadioPanelDropShadowType;
    selectedPanels: string[];
    set_selectedPanels: (selections: string[]) => void;
    selectionType?: 'single' | 'multiple';
    wrapPanels?: boolean;
    panelWidth?: string; // Only applicable for wrapped panels
    maxSelection?: number;
    width?: string;
    height?: string;
}> = ({
    id,
    items,
    theme,
    borderRadius,
    dropShadowType,
    selectedPanels,
    set_selectedPanels,
    selectionType = 'single',
    wrapPanels = false,
    panelWidth,
    maxSelection,
    width = 'auto',
    height = 'auto',
}) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
        '--itemCount': `${items.length}`,
    };

    return (
        <>
            <div
                id={`radioPanelGroup_${id}`}
                className={`radioPanelGroup ${wrapPanels ? 'wrapped' : 'unwrapped'}`}
                style={setStyle}
            >
                {items?.map((panel) => (
                    <RadioPanel
                        id={panel.id}
                        borderRadius={borderRadius}
                        dropShadowType={dropShadowType}
                        selectedPanels={selectedPanels}
                        set_selectedPanels={set_selectedPanels}
                        handleClick={panel.handleClick}
                        enabled={panel.enabled}
                        theme={theme}
                        wrapPanels={wrapPanels}
                        panelWidth={panelWidth}
                        selectionType={selectionType}
                        maxSelection={maxSelection}
                    >
                        {panel.children}
                    </RadioPanel>
                ))}
            </div>
        </>
    );
};
